import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'fr_FR',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'a3cf8109-5a49-4760-b0f4-19f50ce34364',
  ''
);
